import type { IntlShape } from 'react-intl';
import type { ReplyThread } from '../outreachTypes';
import { secondsToClock } from '../outreachFormat';
import { inboxMessages as messages } from './inboxMessages';
import { REPLY_LABEL_TEXT } from './replyLabels';

export interface HistoryLine {
  key: string;
  at: string;
  text: string;
}

/**
 * The history of one thread (design outreach-v2 m1 side panel), oldest first: the pitch, the
 * listen on the pitch page, the reply, the answer and the add.
 */
export function threadHistory(intl: IntlShape, thread: ReplyThread): HistoryLine[] {
  const lines: HistoryLine[] = [];
  if (thread.message.sentAt !== null) {
    lines.push({
      key: 'pitched',
      at: thread.message.sentAt,
      text: intl.formatMessage(messages.historyPitched, { song: thread.songTitle }),
    });
  }
  if (thread.listen !== null) {
    lines.push({
      key: 'listened',
      at: thread.listen.lastAt,
      text: intl.formatMessage(messages.historyListened, { time: secondsToClock(thread.listen.seconds) }),
    });
  }
  lines.push({
    key: 'replied',
    at: thread.receivedAt,
    text: intl.formatMessage(messages.historyReplied, {
      label: intl.formatMessage(REPLY_LABEL_TEXT[thread.label] ?? REPLY_LABEL_TEXT.other),
    }),
  });
  if (thread.answeredAt !== null) {
    lines.push({ key: 'answered', at: thread.answeredAt, text: intl.formatMessage(messages.historyAnswered) });
  }
  if (thread.placement !== null) {
    lines.push({
      key: 'added',
      at: thread.placement.foundAt,
      text: intl.formatMessage(messages.historyAdded, { playlist: thread.placement.targetName }),
    });
  }
  return lines.sort((a, b) => Date.parse(a.at) - Date.parse(b.at));
}
